import * as React from "react";
import { Layout } from "../../../../core/models/enums/core.enums";

const PrwcGridListLayoutButton = (props: any) => {
  const {layout, onChange} = props;

  const handleLayoutChange = () => {
    if (layout === Layout.GRID) {
      onChange(Layout.LIST)
    } else {
      onChange(Layout.GRID);
    }
  }
  
  return (
    <div>
      <div onClick={handleLayoutChange} className={`cursor-pointer flex hover:bg-blue-700 hover:text-white items-center justify-center w-12 h-10 text-xl text-gray-700 border border-gray-300 rounded-md pi ${layout === Layout.GRID ? 'pi-bars': 'pi-th-large'} `}></div>
    </div>
  );
};

export default PrwcGridListLayoutButton;
